module.exports = __webpack_public_path__ + "img/UTEDGE-2.f2422320.jpg";